import { gql } from '@apollo/client';

import { AD_TRAFFICKING_COLUMN } from '../fragments';

export const GET_ADS = gql`
  query GET_ADS(
    $filterOptions: AdFilterOptionsV5
    $sort: AdSortOptionV5
    $order: OrderOption
    $limit: Int
    $offset: Int
  ) {
    ads: adsV5(
      filterOptions: $filterOptions
      sortOptions: { sort: $sort, order: $order }
      paginationOptions: { limit: $limit, offset: $offset }
    ) {
      edges {
        node {
          ...adTraffickingColumn
        }
      }
      total
    }
    getCurrencyPrecisions {
      code
      decimals
    }
  }
  ${AD_TRAFFICKING_COLUMN}
`;
